/* RESPONSIBLE TEAM: team-billing */

export default [
  'AU', // Australia
  'CH', // Switzerland
  'NO', // Norway
  'NZ', // New Zealand
];
